import { gql, TypedDocumentNode } from "@apollo/client";
import type { BackofficeUser } from "@/hooks/useFeatureFlags";

export type UserFeatureFlagQueryResponse = {
  me: BackofficeUser;
};

export const USER_FEATURE_FLAG_QUERY: TypedDocumentNode<UserFeatureFlagQueryResponse> = gql`
  query UserFeatureFlagQuery {
    me {
      id
      externalId
      department
      organization
    }
  }
`;
